import { Component, Input } from '@angular/core';
import { Banner } from '@neb/lit-storybook';

@Component({
  selector: 'gems-banner-alert',
  templateUrl: './gems-banner-alert.component.html',
  styleUrls: ['./gems-banner-alert.component.less'],
  standalone: false
})
export class GemsBannerAlertComponent {
  @Input() banners: Banner[] = [];
}
